import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileUpload.html?raw';
//import docu = require('dojo/text!./FileUploadDocumentation.html');
import FileUploadsDisplay_List from './FileUploadsDisplay_List/FileUploadsDisplay_List';
import "./FileUploadsDisplay_List/FileUploadsDisplay_List";
import ProgressBar from '../../ProgressBar/ProgressBar';
import "../../ProgressBar/ProgressBar";
import FileUploadDisplay_ListRow from './FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import { FileUploadTypes } from "./FileUploadTypes";
import { FileHelpers, StringHelpers, TranslationHelpers } from "../../../../more/Helpers";
import _LabelInputBase from '../../_LabelInputBase/_LabelInputBase';


/**
 * Fileinput, das nach Auswahl von Dateien diese via Filetransfer verpackt hochlädt. Die Files werden einzeln aufgelistet und können entfernt werden.
 * Der Rückgabewert mit getValue liefert die Upload-GUIDs mit File-Metadaten ohne deren Content.
 * Das Backend muss sich zu einem späteren Zeitpunkt um das Entpacken der Uploads kümmern.
 */
class FileUpload extends compose(_LabelInputBase) {
    templateString: any = template;



    //private uploadsDisplayContainer: HTMLElement;
    private txtSelectButtonLabel: HTMLElement;
    private uploadMessagesContainer: HTMLElement;
    private inputContainer: HTMLElement;
    private progressbarContainer: HTMLElement;
    private inputFile: HTMLInputElement;
    private statusContainer: HTMLProgressElement;
    private progressBar: HTMLProgressElement;
    private loaded_n_total: HTMLElement;
    private customFileInputButton: HTMLButtonElement;
    private inputButton_label: string;


    private isCusttomFileInputButton: boolean = false;

    private _lastUploadResponse: any = null;

    private multiple: boolean = true;
    useDisplay: boolean = true;
    maxFileSizeKB: number = 20 * 1024;
    protected _uploads: Array<FileUploadTypes.UploadUnit>;
    private statusText: HTMLElement;
    private uploadedFileNames: Array<string>;
    uploadUrl: string = "filetransfer/upload";
    //iconStatusOk: string = '<i class="fa fa-check w3-text-green" aria-hidden="true"></i>';
    //iconStatusError: string = '<i class="fa fa-times w3-text-red" aria-hidden="true"></i>';

    private uploadedFilesDisplay: MdsLax<InstanceType<typeof FileUploadsDisplay_List>>;

    private onCompleteCallback(response) {
        // ausmustern - callbacks anders lösen mit setup und keinen windig überschriebenen callback-Properties
    }

    constructor(params?) {
        super(...(arguments as unknown as []));
        if(params) lang.mixin(this, params);
    }

    setMultiUpload(bMulti?: boolean) {
        if (bMulti !== true && bMulti !== false) bMulti = true;
        this._setMultipleAttr(bMulti);
    }
    private _setMultipleAttr(value) {
        this.multiple = value;

        //multiple attribute im html input wird net gsetzt weil kein schwein was des widget implementiert des auch gscheid handled
        //this.UiModder.domAttr.set(this.inputFile, "multiple", this.multiple);

        this.txtSelectButtonLabel.innerHTML = this.multiple ? TranslationHelpers.translate("FileTransfer_SelectFiles") : TranslationHelpers.translate("FileTransfer_SelectFile");
    }

    setCustomLabels(fileSelectButtonLabel?: string) {
        if (typeof (fileSelectButtonLabel) != "undefined") {
            if (!fileSelectButtonLabel) {
                this.txtSelectButtonLabel.innerHTML = this.multiple ? TranslationHelpers.translate("FileTransfer_SelectFiles") : TranslationHelpers.translate("FileTransfer_SelectFile");
            } else {
                this.txtSelectButtonLabel.innerHTML = TranslationHelpers.tryTranslate(fileSelectButtonLabel);
            }
        }
    }

    private _getMultipleAttr() {
        return this.multiple;
    }

    private _setCallbackAttr(callback) {
        this.onCompleteCallback = callback;
    }

    _getValueAttr(): Array<FileUploadTypes.UploadUnit> {
        return this.getUploadUnits();
    }

    getUploadByGuid(guid: string): FileUploadTypes.UploadUnit {
        for (let upload of this._uploads) {
            if (upload.guid == guid) return upload;
        }

        return null;
    }

    getUploadGUIDs(): Array<string> {
        return this._uploads.map(record => record.guid);
    }
    getGUIDvalues(): Array<string> {
        return this.getUploadGUIDs();
    }
    /**
     * die aktuellen Upload-Vorgänge
     */
    getUploadUnits(): Array<FileUploadTypes.UploadUnit> {
        return this._uploads;
    }

    /**
     * die aktuellen Uploads als Filedescriptor mit Upload-GUID erhalten
     */
    getUploadedFiles(): Array<FileUploadTypes.UploadDescriptor> {
        let result: Array<FileUploadTypes.UploadDescriptor> = [];
        for (let upload of this._uploads) {
            for (let fileData of upload.files) {
                if (fileData.removed != true) {
                    result.push({
                        Base64Content: fileData.Base64Content,
                        FileName: fileData.FileName,
                        FileSize: fileData.FileSize,
                        LastModified: fileData.LastModified,
                        FileType: fileData.FileType,
                        Extension: fileData.Extension,
                        uploadGUID: upload.guid,
                        FileGUID: upload.guid + StringHelpers.numberToString(result.length, 4),
                        removed: fileData.removed
                    });
                }
            }
        }

        return result;
    }

    getValue(): Array<FileUploadTypes.UploadUnit> {
        return this.getUploadUnits();
    }

    setInputButtonLabel(value: string): void {
        this.UiModder.domAttr.set(this.customFileInputButton, 'innerHTML', value);
    }

    private getFileEntryFromResponse(response: string | object): FileUploadTypes.UploadUnit {
        let entry: FileUploadTypes.UploadUnit = { guid: '', filenames: [], files: [] };

        if (typeof response == "object" && response.hasOwnProperty('Exception')) {
            return null;
        } else if (typeof response == "string" && response != "success") {

            entry.guid = response;
            entry.filenames = this._getFilenamesFromInput();
            entry.files = this._getFileDataFromInput(response);
        }

        this._handleMultiUploadState();

        return entry;
    }

    private _getFilenamesFromInput(): Array<string> {

        let files = this.inputFile.files;
        let fNames = [];
        for (let i = 0; i < files.length; i++) {

            fNames.push(files.item(i).name);

        }
        return fNames
    }

    private _getFileDataFromInput(uploadGuid: string): Array<FileUploadTypes.FileData> {

        let files = this.inputFile.files;
        let result: Array<FileUploadTypes.FileData> = [];
        for (let i = 0; i < files.length; i++) {

            let rawFile = files[i];

            result.push({
                FileName: rawFile.name,
                FileSize: rawFile.size,
                FileType: rawFile.type?.toUpperCase(),
                LastModified: rawFile.lastModified,
                Extension: null,
                removed: false,
                FileGUID: uploadGuid + StringHelpers.numberToString( result.length, 4 )
            });

        }
        return result;
    }

    private displayUploadedFiles(): Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> {

        //let uploaded_fileNames: Array<string> = this.getUploadedFilenames();

        let newRows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> = [];
        if (this._uploads.length > 0 && this.useDisplay) {
            newRows = this.uploadedFilesDisplay.setData(this._uploads);

            for (let row of newRows) {
                this._onNewUploadRow({ name: "rowCreated", row: row }); // LEGACY!
            }
            this._onFileUploadsComplete(newRows);

        } else {
            this.uploadedFilesDisplay.clearRows();
        }

        this.hideNode(this.uploadedFilesDisplay.domNode, this.useDisplay == false);

        return newRows;
    }
    protected _setValidationResultStyle() {
        super._setValidationResultStyle.apply(this, arguments as any);
    }
    protected customValidation(): boolean {
        let result: boolean = false;

        if (this.isMandatory != true) {
            return true;
        }

        if (this._uploads != null && this._uploads.length > 0) {
            result = true;
        }
        return result;
    }

    getUploadedFilenames(): Array<string> {
        return this.uploadedFileNames;
    }
    /**
     * targetGUID ist die GUID eines Uploads (+ zusa)
     */
    removeUploadedFile(targetGUID: string, filename?: string) {
        let unit = this.getUploadByGuid(targetGUID);
        // wenn die GUID eine Upload-UnitZunge ist und kein Filename: Gesamtlöschung ... ?!
        if (!filename && !!unit) {
            this.removeUpload(targetGUID);
            return;
        }
        // ansonsten mal mit den Parametern nach der Uploadrow ausschau halten:
        let row = this.uploadedFilesDisplay.getListEntry(targetGUID, filename);
        if (row) {
            row.removeUploadedFile();
        } else {
            this.removeUpload(targetGUID, filename);
        }
    }

    private removeUpload(uploadGUID: string, filename?: string, callback?: Function) {
        this.StandbyStart();

        let requestUrl = window.appRoot + "filetransfer/remove";

        let data = {
            guid: uploadGUID,
            fileName: filename
        };

        this.RequestManager.post(
            requestUrl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onRemoveUploadResponse, callback),
            lang.hitch(this, this._onRemoveUploadError)
        );
    }

    //deleteUploadedFileAndRow(uploadGUID: string, filename: string): void {
    //    let row = this.uploadedFilesDisplay.getListRow(uploadGUID, filename);
    //    if (row) {
    //        row.removeUploadedFile();
    //    }
    //}

    private _onRemoveUploadResponse(callback: Function, response) {
        if (typeof (callback) == "function") callback();
    }

    private _onRemoveUploadError(error) {
    }

    private mcProgressBar: MdsLax<InstanceType<typeof ProgressBar>> = null;

    private checkInputFileSize(rawInputFile: File): boolean {
        if (rawInputFile.size == 0){
            let fileName = rawInputFile?.name ?? "unknown";
            let toastTxt = this.translate("SimpleFileUpload__Message_NoEmptyFile");
            toastTxt = toastTxt.replaceAll("{0}", fileName);
            this.showToast(toastTxt, "fas fa-file-circle-xmark");
            return false;
        }
        if (!this.maxFileSizeKB || this.maxFileSizeKB < 0) return true;
        if (!rawInputFile) return false;

        let sizeBytes = this.maxFileSizeKB * 1024;

        if (rawInputFile.size > sizeBytes) {
            let message = this.UiModder.domConstruct.create("p", { className: "warningBG uploadMessage" }, this.uploadMessagesContainer);
            this.UiModder.domConstruct.create("span", {
                className: "main",
                innerHTML: StringHelpers.stringFormat(TranslationHelpers.translate("FileUpload__Message_Oversize"),
                    "<i>" + rawInputFile.name + "</i>",
                    FileHelpers.formatBytes(sizeBytes, 0)
                )
            }, message);
            return false;
        }

        return true;
    }

    private _onchangeFileInput(evt) {

        if (this.inputFile.files?.length) {

            if (this.multiple != true) {
                if (this._uploads.length > 0) {
                    for (let upload of this._uploads) {
                        this.removeUploadedFile(upload.guid);
                    }
                }
                this.uploadedFilesDisplay.clearRows();

                this.uploadedFileNames = [];
                this._uploads = [];
            }


            this._uploadFile();
        }
    }
    private _uploadFile(evt?) {
        let formdata = new FormData();
        this.UiModder.domConstruct.empty(this.uploadMessagesContainer);

        let count = 0;
        for (let i = 0; i < this.inputFile.files.length; i++) {
            let file = this.inputFile.files[i];
            if (this.checkInputFileSize(file)) {
                formdata.append("files", file);
                count++;
            }
        }

        if (count == 0) {
            this.inputFile.value = null;
            return;
        }

        this.setProgressVisibility(true);

        this.UiModder.domClass.add(this.inputContainer, "w3-disabled");

        var ajax = new XMLHttpRequest();
        ajax.withCredentials = true;
        ajax.upload.addEventListener("progress", lang.hitch(this, this._onUploadProgress), false);
        ajax.addEventListener("load", lang.hitch(this, this._onUploadComplete), false);
        ajax.addEventListener("error", lang.hitch(this, this._onUploadError), false);
        ajax.addEventListener("abort", lang.hitch(this, this._onUploadAbort), false);
        ajax.onloadend = lang.hitch(this, function () {
            if (ajax.status == 404 || ajax.status == 500)
                lang.hitch(this, "_upload_errorHandler")();
        });

        ajax.open("POST", window.appRoot + this.uploadUrl);

        ajax.send(formdata);

    }


    private _onUploadProgress(event: ProgressEvent) {
        this.loaded_n_total.innerHTML = this.stringFormat(this.translations["FileTransfer_Progressbar__TotalLoaded"], event.loaded, event.total);// "Uploaded " + event.loaded + " bytes of " + event.total;
        let percent = Math.round((event.loaded / event.total) * 100);
        this.progressBar.value = percent;
        this.mcProgressBar.setNewTarget(percent);
        this.UiModder.domClass.remove(this.statusText, "uploadERROR uploadOK");
        //this.statusText.innerHTML = this.stringFormat(this.translations["FileTransfer_Progressbar__PercentProgress"], Math.round(percent).toString());// Math.round(percent) + "% uploaded... please wait";

    }

    private _onUploadComplete(event: any) {

        this.progressBar.value = 0;

        setTimeout(lang.hitch(this, this.setProgressVisibility, false), 1000);
        //this.setProgressVisibility(false);


        this._lastUploadResponse = JSON.parse(event.target.responseText);
        let newUploadEntry = this.getFileEntryFromResponse(this._lastUploadResponse);

        //console.log(this.id + " upload complete", this._lastUploadResponse, newUploadEntry, event);

        if (this._lastUploadResponse.Type === "Exception") {
            console.error("Fileupload ERROR: ", event, this._lastUploadResponse);
            //this.status.innerHTML = this.iconStatusError;
            this.UiModder.domClass.add(this.statusText, "uploadERROR");
        } else {

            let fileNames: Array<string> = newUploadEntry.filenames;
            this.uploadedFileNames.push(...fileNames);
            //this.status.innerHTML = this.iconStatusOk;
            //this.UiModder.domClass.add(this.statusText, "uploadOK");
            this._uploads.push(newUploadEntry);
            //this.addFileDisplay(newUploadEntry);
        }

        let listRows = this.displayUploadedFiles();
        listRows.forEach((lr)=>{
            lr.on("fileRemoved", lang.hitch(this, (fileRemoved: FileUploadTypes.UploadDescriptor) => {
                this.emit("fileRemoved", fileRemoved);
            }));
        });


        this._handleMultiUploadState();

        if (this.onCompleteCallback) this.onCompleteCallback(this._lastUploadResponse); // callback
        this.emit("complete", this._lastUploadResponse); // event // man darf beides verwenden ...
        this.emit("change", this._uploads);
        //this.checkValidity();

    }

    private _onUploadError(event: ProgressEvent) {
        this.UiModder.domClass.add(this.statusText, "uploadERROR");

        console.warn(this.id + " upload error", event);
        //this.checkValidity();

        this.setProgressVisibility(false);
    }

    private _onUploadAbort(event: ProgressEvent) {
        this.UiModder.domClass.add(this.statusText, "uploadAborted");
        this.statusText.innerHTML = this.translations["FileTransfer_Status__UploadAborted"]; //"Upload Aborted";
        //this.checkValidity();

        this.setProgressVisibility(false);
    }

    private _onClick_AbortUpload(evt: MouseEvent) {
        this._onUploadAbort(null);
    }

    private setProgressVisibility(visible: boolean = true) {
        this.UiModder.domClass.remove(this.statusText, "uploadERROR uploadOK uploadAborted");

        if (visible === false) {

        }

        this.hideNode(this.statusContainer, visible === false);
        this.hideNode(this.loaded_n_total, visible === false);
        this.hideNode(this.progressBar, visible === false);
        this.hideNode(this.progressbarContainer, visible === false);
        this.UiModder.domClass.toggle(this.inputContainer, "w3-disabled", visible === true);

        if (visible) {
            this.progressbarContainer.innerHTML = "";
            this.mcProgressBar = new ProgressBar;
            this.mcProgressBar.placeAt(this.progressbarContainer);

        } else {
            if (this.mcProgressBar) {

            }
        }
    }

    private _handleMultiUploadState() {
        if (this.multiple == false) {
            this.inputFile.disabled = this.isReadonly || this._uploads.length > 0;
            this.hideNode(this.isReadonly || this.inputContainer, this._uploads.length > 0);
        } else {
            this.inputFile.disabled = this.isReadonly;
            this.hideNode(this.isReadonly);
        }
    }

    private _onfileRemoved(file: FileUploadTypes.UploadDescriptor) {
        //{guid: "1afbf8b5-a209-4436-9161-9f3093564d86", filename: "npmBasicCommand.txt"}
        if (!file) return;

        let filename = file.FileName
        let guid = file.uploadGUID

        // clearing this.uploadedFileNames
        let index:number = this.uploadedFileNames.indexOf(filename);
        this.uploadedFileNames.splice(index, 1);

        let keepUploads = [];
        // clearing this._value
        for (let upload of this._uploads) {

            if ((upload.guid.match(guid) ?? []).length > 0) {
                for (let fileData of upload.files) {
                    if (fileData.FileName == filename) {
                        fileData.removed = true;
                        break;
                    }
                }

                let filenameIndex = upload.filenames.indexOf(filename);
                if (filenameIndex != -1) {
                    upload.filenames.splice(filenameIndex, 1);
                    file.removed = true;

                    if (upload.filenames.length == 0) {

                    } else {
                        keepUploads.push(upload);
                    }
                } else {

                }
            } else {
                keepUploads.push(upload);
            }
        }

        this._uploads = keepUploads;

        //this.status.innerHTML = null;
        this.UiModder.domConstruct.empty(this.statusText);
        this.UiModder.domClass.remove(this.statusText, "uploadOK");


        // die Daten neu setzen, true-flag entfernt Elemente die nicht mehr vorhanden sind
        this.uploadedFilesDisplay.setData(this.getValue(), true);

        this.inputFile.value = null;

        this._handleMultiUploadState();

        this.emit("complete_remove", file);
        this.emit("remove", file);
        this.emit("change", this._uploads);
    }


    private _onfileRemove_Error(err: object): void {
        console.error("_onFileRemove_error", err);
    }

    showCustomSelectButton(bool: boolean = true): void {

        this.UiModder.domClass.toggle(this.inputFile, 'hidden', bool);
        this.hideNode(this.customFileInputButton, bool);
        this.UiModder.domClass.toggle(this.customFileInputButton, "true", bool);
    }


    setup(config: {
        uploadCallback?: (newRows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>>) => any
        maxFileSizeMB?: number,

    }) {

        if (!config) return;

        if (config.uploadCallback) this._uploadCallbacks.push(config.uploadCallback);
    }

    private _uploadCallbacks: Array<(newRows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>>) => any>;

    private _onFileUploadsComplete(newRows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>>) {
        for (let callback of this._uploadCallbacks) {
            callback(newRows);
        }
    }

    private _onNewUploadRow(data: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }) {
        //console.debug(this.id + " _onNewUploadRow, emit NewRowCreated");
        this.emit("NewRowCreated", data);
    }

    private _onClick_SelectFiles(evt: PointerEvent): void {
        evt.stopPropagation();
        this.inputFile.click();
    }

    resetFileUpload(): void {
        this.uploadedFilesDisplay.clearRows();

        this._uploads = [];
        this.uploadedFileNames = [];
        this._handleMultiUploadState();
    }

    loadFileUploadFromData(files: Array<FileUploadTypes.UploadUnit>) {

        if (!files) return;

        this._uploads = files;
        this.displayUploadedFiles();
    }

    // Doku
    //getDocumentationContent(): string {
    //    return docu;
    //}

    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.customFileInputButton, "selectFileBtn");
    }

    // Dojo
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._uploads = [];
        this.uploadedFileNames = [];

        this._uploadCallbacks = [];

        this.setProgressVisibility(false);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileUpload);
